module.exports = __webpack_public_path__ + "res/dummy_prediction2.9727930b19ea2e7e6d03a49d461907dc.png";